module.exports = __webpack_public_path__ + "media/images/japan/underline_raw-c2335699cde2932fb310b0523492a28a.svg";